import { render, staticRenderFns } from "./page-section.vue?vue&type=template&id=2b8cfc48&scoped=true&"
import script from "./page-section.vue?vue&type=script&lang=js&"
export * from "./page-section.vue?vue&type=script&lang=js&"
import style0 from "./page-section.vue?vue&type=style&index=0&id=2b8cfc48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8cfc48",
  null
  
)

export default component.exports